import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AccountCategoryCode, DkimDomain } from '../models';

@Injectable()
export class DkimService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('privateDomainUrl') private readonly privateDomainUrl: string,
  ) {}

  public getDomains(
    accountId: string,
    category: AccountCategoryCode,
  ): Observable<DkimDomain> {
    return this.httpClient.get<DkimDomain>(
      `${this.privateDomainUrl}bo/from-domains/${accountId}?accountCategory=${category}`,
    );
  }

  public updateDomains(
    accountId: string,
    category: AccountCategoryCode,
    domains: DkimDomain,
  ): Observable<DkimDomain> {
    return this.httpClient.put<DkimDomain>(
      `${this.privateDomainUrl}bo/from-domains/${accountId}?accountCategory=${category}`,
      domains,
    );
  }
}
